import { apiClient, Auth } from '@/shared/api'

import { TRoomContractPolicy } from '../model/schema'

export type RoomContractPolicyParams = {
  roomId: number
}

export const getRoomContractPolicy = async ({
  roomId,
}: RoomContractPolicyParams) => {
  const { data } = await apiClient.get<TRoomContractPolicy>({
    endpoint: `/host/rooms/${roomId}/contract-policy`,
    auth: Auth.REQUIRED,
  })

  return data
}
